/* eslint-disable react/react-in-jsx-scope */
import { Box, Button, CircularProgress, TextField } from "@mui/material"
import CustomModal from "components/Common/CustomModal"
import CustomTable from "components/Common/CustomTable"
import Grid from "components/Common/Grid"
import { useEffect, useMemo, useState } from "react"
import { FaExclamationTriangle } from "react-icons/fa"
import { toast } from "react-toastify"
import { getPublications, getTags, postAnalise } from "./apiRequest"
import AnaliseAllModalContent from "./Components/analiseAllModalContent"
import ModalContent from "./Components/detailsModalContent"
import TagsObsModalContent from "./Components/tagsObsModalContent"
import { parseFinalPublicationsTable } from "./helpers/parseFinalPublicationsTable"

const ResultadosPublicacaoFinal = () => {
  const [rowsSelected, setRowsSelected] = useState([])
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [detailsModalOpen, setDetailsModalOpen] = useState(false)
  const [analiseAllModalOpen, setAnaliseAllModalOpen] = useState(null)
  const [detailsModalContent, setDetailsModalContent] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [filterText, setFilterText] = useState("")
  const [totalItems, setTotalItems] = useState(null)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [tags, setTags] = useState([])
  const [filteredIds, setFilteredIds] = useState([])
  const [isAllChecked, setIsAllChecked] = useState(false)
  const [tagsObsModalData, setTagsObsModalData] = useState({
    id: null,
    isOpen: false,
  })

  const analiseBtnDisable = useMemo(() => {
    if (rowsSelected.length) {
      return rowsSelected.some(row => !!row.isSend)
    }
    return false
  }, [rowsSelected])

  const handleGetPublications = data => {
    getPublications({
      page: data?.page || currentPage,
      size: 10,
      startDate: data?.startDate || "",
      endDate: data?.endDate || "",
      text: data?.text || "",
      setTableData,
      setCurrentPage,
      setTotalPages,
      setLoading,
      setTotalItems,
      setFilteredIds,
    })
  }

  const handleAnalise = analise => {
    setLoading(true)

    const rowsFiltered = rowsSelected.filter(row => !!row.isSend)
    console.log(rowsFiltered)
    postAnalise({ rowsSelected: rowsFiltered, analise })
      .then(message => {
        setRowsSelected([])

        handleGetPublications({
          startDate,
          endDate,
          text: filterText,
        })

        toast.success(message)
      })
      .finally(() => {
        setLoading(false)
        setAnaliseAllModalOpen(null)
      })
  }

  const handleRowsSelected = (id, isChecked) => {
    const rowExists = rowsSelected.find(item => item.id === id)
    const newRowSelected = [...rowsSelected]

    if (rowExists) {
      const rowIndex = rowsSelected.findIndex(item => item.id === id)

      newRowSelected[rowIndex] = {
        ...newRowSelected[rowIndex],
        isSend: isChecked,
      }

      setRowsSelected(newRowSelected)
    } else {
      setRowsSelected([...newRowSelected, { id, isSend: true }])
    }
  }

  const handleTagsObsModalSave = ({ id, comment, tag }) => {
    const rowExists = rowsSelected.find(item => item.id === id)
    const newRowSelected = [...rowsSelected]

    if (rowExists) {
      const rowIndex = rowsSelected.findIndex(item => item.id === id)

      newRowSelected[rowIndex] = {
        ...newRowSelected[rowIndex],
        tag,
        observacao: comment,
      }

      setRowsSelected(newRowSelected)
    } else {
      setRowsSelected([
        ...newRowSelected,
        { id, isSend: false, tag, observacao: comment },
      ])
    }
  }

  const handleAllSelected = isAllChecked => {
    const allSelected = filteredIds.map(id => {
      const rowById = rowsSelected.find(item => item.id === id)

      if (rowById) {
        return { ...rowById, isSend: isAllChecked }
      }
      return { id, isSend: isAllChecked }
    })

    setRowsSelected(allSelected)
    setIsAllChecked(isAllChecked)
  }

  const onOpenDetails = content => {
    setDetailsModalContent(content)
    setDetailsModalOpen(true)
  }

  const onOpenTags = row => {
    setTagsObsModalData({ id: row.Id, isOpen: true })
  }

  const handlePagination = page => {
    handleGetPublications({
      page,
      startDate,
      endDate,
      text: filterText,
    })
  }

  useEffect(() => {
    handleGetPublications()
    getTags(setTags)
  }, [])

  return (
    <Box
      sx={{
        marginTop: "102px",
        padding: "0 32px 60px 32px",
      }}
    >
      <span style={{ fontSize: "18px", fontWeight: 500, lineHeight: "18px" }}>
        Resultados de publicação final
      </span>

      <Grid columnQuantity={4} marginTop={32}>
        <TextField
          label="Filtrar por texto"
          variant="outlined"
          size="small"
          value={filterText}
          onChange={({ target }) => setFilterText(target.value)}
          onKeyDown={event => {
            if (event.key === "Enter") {
              handleGetPublications({
                startDate,
                endDate,
                text: filterText,
              })
            }
          }}
          fullWidth
        />
        <TextField
          label="Data Inicial"
          variant="outlined"
          type="date"
          size="small"
          value={startDate}
          onChange={({ target }) => setStartDate(target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Data Final"
          variant="outlined"
          type="date"
          size="small"
          value={endDate}
          onChange={({ target }) => setEndDate(target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant="outlined"
          sx={{ backgroundColor: "#677de8", color: "#FFF" }}
          onClick={() =>
            handleGetPublications({
              startDate,
              endDate,
              text: filterText,
            })
          }
        >
          Filtrar
        </Button>
      </Grid>
      <Grid columnQuantity={4} marginTop={16}>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#677de8", color: "#FFF" }}
          onClick={() =>
            isAllChecked
              ? setAnaliseAllModalOpen({
                  isOpen: true,
                  analiseBtn: true,
                })
              : handleAnalise(true)
          }
          disabled={!analiseBtnDisable}
        >
          Analisar
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() =>
            isAllChecked
              ? setAnaliseAllModalOpen({
                  isOpen: true,
                  analiseBtn: false,
                })
              : handleAnalise(false)
          }
          disabled={!analiseBtnDisable}
        >
          Não Analisar
        </Button>
      </Grid>
      <Grid columnQuantity={4} marginTop={16}>
        <div>
          <span>TOTAL DE REGISTROS: </span>
          <span style={{ fontWeight: 500, color: "#677de8" }}>
            {totalItems}
          </span>
        </div>
      </Grid>

      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ marginTop: "16px" }}>
          <CustomTable
            data={parseFinalPublicationsTable({
              data: tableData,
              tags,
              filteredIds,
              isAllChecked,
              onAllSelected: handleAllSelected,
              onOpenDetails,
              onOpenTags,
              rowsSelected,
              onRowSelect: handleRowsSelected,
            })}
            pagination={{
              currentPage,
              totalPages,
              onPageChange: page => handlePagination(page),
            }}
            autoHeight
          />
          <CustomModal
            title="Detalhes da publicação final"
            open={detailsModalOpen}
            onClose={() => setDetailsModalOpen(false)}
          >
            <ModalContent data={detailsModalContent} filterText={filterText} />
          </CustomModal>
          <CustomModal
            title="Seleção de tag e observações"
            open={tagsObsModalData.isOpen}
            onClose={() => setTagsObsModalData({ id: null, isOpen: false })}
          >
            <TagsObsModalContent
              tags={tags}
              modalData={tagsObsModalData}
              rowsSelected={rowsSelected}
              onSave={tagObsData => {
                handleTagsObsModalSave(tagObsData)
                setTagsObsModalData({ id: null, isOpen: false })
              }}
            />
          </CustomModal>
          <CustomModal
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <FaExclamationTriangle color="#FFA500" size={20} />
                <span>ATENÇÃO</span>
              </div>
            }
            open={!!analiseAllModalOpen?.isOpen}
            onClose={() => setAnaliseAllModalOpen(false)}
          >
            <AnaliseAllModalContent
              analiseBtn={analiseAllModalOpen?.analiseBtn}
              onConfirm={() => handleAnalise(analiseAllModalOpen?.analiseBtn)}
            />
          </CustomModal>
        </Box>
      )}
    </Box>
  )
}

export default ResultadosPublicacaoFinal
